import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API_URI = process.env.REACT_APP_API_URI;
const CloudUrl = process.env.REACT_APP_CLOUD_FLARE_URL;

const BlogDetail = () => {
  const { id } = useParams(); 
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('token'); 

  useEffect(() => {
    const authHeaders = token ? { 'Authorization': `Bearer ${token}` } : {};

    const fetchBlog = async () => {
      if (!id) {
        setError('Invalid blog ID.');
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${API_URI}/api/blogs/${id}`, { headers: authHeaders });

        if (response.status !== 200) {
          throw new Error(`Error fetching blog: ${response.statusText}`);
        }

        const data = response.data;

        setBlog({
          ...data,
          imageUrl: data.images && data.images.length
            ? `${CloudUrl}/${data.images[0]}`
            : ''
        });
      } catch (error) {
        console.error('Error fetching blog:', error);
        setError(error.response?.data?.error || 'Failed to load the blog. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id, token]); // Removed authHeaders from dependencies

  if (loading) {
    return (
      <div className="bg-black text-white p-8 min-h-screen flex items-center justify-center">
        <p className="text-xl">Loading blog details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-black text-white p-8 min-h-screen flex flex-col items-center justify-center">
        <p className="text-xl mb-4">{error}</p>
        <button
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded transition-all duration-700"
          onClick={() => window.location.reload()}
        >
          Retry
        </button>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="bg-black text-white p-8 min-h-screen flex items-center justify-center">
        <p className="text-xl">Blog not found.</p>
      </div>
    );
  }

  return (
    <div className="bg-black text-white p-8 md:p-16 min-h-screen">
      {/* Hero Section */}
      <div className="p-1 md:p-5 rounded-lg mb-1 mx-1 md:mx-8">
        <h1 className="text-3xl md:text-5xl font-bold mb-6 text-center">{blog.title}</h1>
        {blog.imageUrl && (
          <img
            src={blog.imageUrl}
            alt="Blog Hero"
            className="w-full h-auto max-h-96 object-cover mb-1 rounded-lg"
          />
        )}
      </div>

      {/* Content Section */}
      <div className="prose prose-lg prose-invert max-w-none mx-4 md:mx-16">
        <div dangerouslySetInnerHTML={{ __html: blog.content }} />
      </div>

      {/* Additional Images */}
      {blog.images && blog.images.slice(1).map((img, idx) => (
        <img
          key={idx}
          src={`${CloudUrl}/${img}`}
          alt={`Extra #${idx}`}
          className="mt-4 w-full max-w-screen-md object-cover rounded"
        />
      ))}
    </div>
  );
};

export default BlogDetail;
